import { render, staticRenderFns } from "./EmailNCC.vue?vue&type=template&id=63a21e62&scoped=true"
import script from "./EmailNCC.vue?vue&type=script&lang=ts"
export * from "./EmailNCC.vue?vue&type=script&lang=ts"
import style0 from "./EmailNCC.vue?vue&type=style&index=0&id=63a21e62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a21e62",
  null
  
)

export default component.exports